import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Message, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { NumberSeriesViewTabIndex } from '../constant/series.enum';
import { SeriesService } from '../services/series-service';
import { NoSeries } from './models/noSeries';
import { noSeriesStartEndEndValidator } from '../../../modules/shared/validators/no-series-start-end.validator';

@Component({
  selector: 'app-series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.scss']
})
export class SeriesComponent implements OnInit, OnDestroy {
  selectedTabIndex = NumberSeriesViewTabIndex.CRM;
  numberSeriesViewTabIndex: NumberSeriesViewTabIndex;
  displayEditNumber = false;
  selectedModuleHeader: string;
  num: number;
  isEdited = false;
  numberSeriesForm: FormGroup;
  maxNoMessage:Message[];
  saveButton :boolean;
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  tempSerial: any = {
    moduleId: 0,
    prefix: "",
    startingSequenceNumber: "",
    endingSequenceNumber: "",
    lastUsedSequenceNumber: "",
    enableAutoGeneration: false,
    enableManualEntry: false

  };
  returnNumber = 0;
  series: NoSeries[];

  editCheckbox: any = {
    prefix: '',
    startingSequenceNumber: 0,
    endingSequenceNumber: 0,
    lastUsedSequenceNumber: 0,
    enableAutoGeneration: false,
    enableManualEntry: false
  }

  constructor(private seriesService: SeriesService, private messageService: MessageService, public fb: FormBuilder) { }

  ngOnInit(): void {
    this.maxNoMessage = [];
    this.seriesForm();
    this.getSeriesNo();

  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }
  seriesForm(seriesDetails: NoSeries = null) {
    this.isEdited = false;
    this.numberSeriesForm = this.fb.group({
      moduleId: [seriesDetails?.moduleId || 0,],
      moduleName: [seriesDetails?.moduleName || '', Validators.required],
      prefix: [seriesDetails?.prefix || '', [Validators.maxLength(3), Validators.required]],
      startingSequenceNumber: [seriesDetails?.startingSequenceNumber || null, Validators.required],
      endingSequenceNumber: [seriesDetails?.endingSequenceNumber || null, Validators.required],
      lastUsedSequenceNumber: [seriesDetails?.lastUsedSequenceNumber || null],
      lastUsedDate: [seriesDetails?.lastUsedDate || ''],
      enableAutoGeneration: [seriesDetails?.enableAutoGeneration || false, Validators.required],
      enableManualEntry: [seriesDetails?.enableManualEntry || false, Validators.required]
    },
      {
        validator: noSeriesStartEndEndValidator
      }
    )
    this.numberSeriesForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(formData => {
      this.isEdited = !(JSON.stringify(formData) == JSON.stringify(this.tempSerial))
    });
  }

  getSeriesNo() {
    this.seriesService.systemSeriesNo().subscribe((seriesData: NoSeries[]) => {
      this.series = seriesData.filter(series=> series.moduleId !=303 && series.moduleId !=304);
    }, (error) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to Load Data'
      });
    })
  }

  editNumber(product) {
    this.seriesForm(product);
    this.tempSerial = JSON.parse(JSON.stringify(product));
    this.calulateNumber();
    this.displayEditNumber = true;
    this.selectedModuleHeader = product.moduleName;
  }

  calulateNumber() {
    let start = Number(this.numberSeriesForm.value.startingSequenceNumber);
    let end = Number(this.numberSeriesForm.value.endingSequenceNumber);
    this.num = end - start + 1;
    if (end >= start && start > 0) {
      this.returnNumber = this.num;
    } else {
      this.returnNumber = 0;
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  characterOnly(event): boolean {

    const character = (event.which) ? event.which : event.keyCode;
    if (character === 32) {
      return false; // Prevent space character
    }
    if (
      (character >= 65 && character <= 90) || // Uppercase letters
      (character >= 97 && character <= 122) || // Lowercase letters
      (character >= 33 && character <= 47) || // Special characters
      (character >= 58 && character <= 64) || // Special characters
      (character >= 91 && character <= 96) || // Special characters
      (character >= 123 && character <= 126) // Special characters
    ) {
      return true;
    }
    return false;

  }

  onCheckboxChange(product: any, checkboxType: 'auto' | 'manual') {
    // const checkboxesChecked = product.enableAutoGeneration || product.enableManualEntry;
    // // console.log(checkboxesChecked);
    // if (checkboxesChecked) {
    //   if (checkboxType == 'auto' && product.enableAutoGeneration) {
    //     // this.seriesService.editSeriesCheckBox(product).subscribe((checkedData)=>{
    //     // console.log(checkedData)
    //     // this.editCheckbox=checkedData;
    //     // this.messageService.add
    //     // ({
    //     //   severity:  'success',
    //     //   summary: 'Success',
    //     //   detail: ' Sucessfully Enabled'
    //     // });
    //     //})
    //   } else if (checkboxType == 'auto' && !product.enableAutoGeneration) {
    //     this.seriesService.editSeriesCheckBox(product).subscribe((checkedData) => {
    //       this.editCheckbox = checkedData;
    //       this.messageService.add({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: ' Sucessfully disabled'
    //       });
    //     })

    //   } else if (checkboxType == 'manual' && product.enableManualEntry) {
    //     this.seriesService.editSeriesCheckBox(product).subscribe((checkedData) => {
    //       this.editCheckbox = checkedData;
    //       this.messageService.add({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: ' Sucessfully Enabled'
    //       });
    //     })
    //   } else if (checkboxType == 'manual' && !product.enableManualEntry) {
    //     this.seriesService.editSeriesCheckBox(product).subscribe((checkedData) => {
    //       this.editCheckbox = checkedData;
    //       this.messageService.add({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: ' Sucessfully disabled'
    //       });
    //     })
    //   }
    // } else {
    //   if (checkboxType == 'auto') product.enableAutoGeneration = true;
    //   if (checkboxType == 'manual') product.enableManualEntry = true;
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error',
    //     detail: 'At least one method(automatic/manual) needs to be enabled'
    //   });
    // }
    // return;
  }

  save() {
    if (this.returnNumber >= 10000)
     {
      this.seriesService.editSystemSeriesNO(this.numberSeriesForm.value).subscribe((editSeriesData) => {
        this.tempSerial = editSeriesData;
        console.log(this.series)
        console.log(editSeriesData)
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Details Edited Sucessfully'
        });
        this.displayEditNumber = false;
        this.getSeriesNo();
      })

    } else {
      this.displayEditNumber = true;
      //this.maxNoMessage=[{ severity: 'error', summary: 'Error', detail: 'Max No must be at least 10000.' }];
    }
  }
}
